import React, { useState } from 'react';
import BodyContainer from '../BodyContainer';
import GroupSharpIcon from '@material-ui/icons/GroupSharp';
import makeStyles from '@material-ui/core/styles/makeStyles';
import useWindowDimensions from '../../theme/useWindowDimensions';
import { Grid } from '@material-ui/core';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';
import TextField from '@material-ui/core/TextField';
import TextFieldComp from '../TextFieldComp';
import { TextareaAutosize } from '@material-ui/core';
import CustomButton from '../viewEventUi/CustomButton';
import { emailListStyles } from '../../styles/emailListStyles';
import { isEmail } from '../../regexFuncs';
import Services from '../../services/services';
import toast, { Toaster } from 'react-hot-toast';
import Loader from '../Loader';
import { Logger } from 'twilio-video';
import { getUserBrowserStorage, getSessionItem } from '../../constants';

const useStyles = makeStyles((theme) => emailListStyles(theme));

const EmailList = () => {
  const classes = useStyles();
  const { height, width } = useWindowDimensions();

  const [emailListName, setEmailListName] = useState({
    error: false,
    helpertext: ' ',
    value: '',
  });

  const [emailDump, setEmailDump] = useState({
    error: false,
    helpertext: ' ',
    value: '',
  });

  const [uploadFile, setUploadFile] = useState(null);
  const [loader, setLoader] = React.useState(false);
  const [response, setresponse] = useState([]);

  const userDetails = JSON.parse(getUserBrowserStorage('userDetails'));

  const userId = userDetails?.userId;

  const onChangeEmail = async (e) => {
    const value = e.target.value;
    setEmailListName({
      error: false,
      helpertext: null,
      value: value,
    });
  };
  // console.log(emailListName);

  const onChangeEmailDump = async (e) => {
    const value = e.target.value;
    setEmailDump({
      error: false,
      helpertext: null,
      value: value,
    });
  };
  // console.log(emailDump);

  const FileUploadFunc = async (e) => {
    const file = e.target.files[0];
    if (!file) {
      setUploadFile(null);
      return;
    }
    setUploadFile(file);
  };
  // console.log(uploadFile);

  const Validation_fun = () => {
    let errors = {};
    if (!emailListName.value) {
      errors.emailListName = true;
      setEmailListName((prevState) => {
        return {
          ...prevState,
          error: true,
          helpertext: 'Email List name is required',
        };
      });
      // toast.error("Email List name is required", { duration: 4000 });
    }

    if (!emailDump.value) {
      errors.emailDump = true;
      // setEmailDump((prevState) => {
      //   return {
      //     ...prevState,
      //     error: true,
      //     helpertext: "Atleast one of email dump or csv file is required ",
      //   };
      // });
    }

    if (!uploadFile) {
      errors.uploadFile = true;
      // setUploadFile((prevState) => {
      //   return {
      //     ...prevState,
      //   }}
      // );
    }

    if (!emailDump.value && uploadFile === null) {
      errors.emailDump = true;
      setEmailDump((prevState) => {
        return {
          ...prevState,
          error: true,
          helpertext: 'enter any one',
        };
      });
      // toast.error("Email List must be updated in atleast one of the fields", { duration: 4000 });
    }

    if (errors?.emailListName || (errors?.emailDump && errors?.uploadFile)) {
      return false;
    } else {
      return true;
    }
  };

  const createEmailList = () => {
    if (Validation_fun()) {
      let emailList_data = {
        userid: userId,
        orgid: 2,
        emailListName: emailListName.value,
        email: emailDump.value,
        file: uploadFile,
        // userType: okNoFor,
      };
      setLoader(!loader);

      Services.create_emailList(emailList_data)
        .then((userResponse) => {
          if (
            userResponse.data.responseCode === 200 ||
            userResponse.data.responseCode === 201
          ) {
            setLoader(false);
            console.log(userResponse);
            toast.success('Email List created successfully', {
              duration: 4000,
            });
            // history.push("/");
            setresponse(userResponse.data.data);
          } else {
            setLoader(false);
            toast.error('failed', { duration: 4000 });
          }
        })
        .catch((error) => {
          setLoader(false);
          toast.error('failed', { duration: 4000 });
        });
    } else {
      // toast.error("failed", { duration: 4000 });
    }
  };

  return (
    <BodyContainer title='Email List'>
      <Grid className={classes.gridOccupy}>
        <div className={classes.container} style={{}}>
          <Paper elevation={0} className={classes.root1}>
            <Box display='flex' justifyContent='' alignItems=''>
              <form className={classes.form}>
                {/* <Grid
                  container
                  style={{
                    dislay: "flex",
                    flexDirection: "column",
                    margin: "4px",
                  }}
                >
                  <label className={classes.label}>Email List Name *</label>
                  <input
                    required
                    type="text"
                    onChange={onChangeEmail}
                    label="Email *"
                    // placeholder="Email"
                    className={classes.inputEmail}
                  />
                </Grid> */}

                <Grid
                  container
                  style={{
                    dislay: 'flex',
                    flexDirection: 'column',
                    margin: '4px',
                  }}
                >
                  <TextFieldComp
                    // disabled={dataFrom === 'UpcomingEvents' ? true : false}
                    name='emaiListName'
                    label='Email List Name *'
                    placeholder='Name of the email List'
                    required={true}
                    value={emailListName.value}
                    error={emailListName.error}
                    helpertext={emailListName.helpertext}
                    onChange={onChangeEmail}
                    className={classes.inputStyles}
                  />
                </Grid>

                <Grid
                  container
                  style={{
                    dislay: 'flex',
                    flex: 1,
                    flexDirection: 'column',
                    // alignItems: "baseline",
                    margin: '4px',
                  }}
                >
                  <TextFieldComp
                    name='emailDump'
                    label='Email Dump *'
                    placeholder='Email Dump'
                    value={emailDump.value}
                    error={emailDump.error}
                    helpertext={emailDump.helpertext}
                    onChange={onChangeEmailDump}
                    multiline={true}
                    className={classes.inputStyles}
                    required={true}
                    minRows={10}
                    maxRows={16}
                    style={{ display: 'flex', flex: 1 }}
                  />
                </Grid>

                {/* <Grid
                  container
                  style={{
                    dislay: "flex",
                    flexDirection: "column",
                    alignItems: "baseline",
                    margin: "4px",
                  }}
                >
                  <label className={classes.label}>Mail Dump</label>
                  <TextareaAutosize
                    rows={8}
                    name="EmailDump" 
                    name="EmailDump"
                    label="Email Dump *"
                    placeholder="E-mail adresses must be separated with ','"
                    onChange={onChangeEmailDump}
                    // placeholder="MailList"
                    className={classes.inputMailDump}
                  />
                </Grid> */}
                <Grid
                  container
                  style={{
                    dislay: 'flex',
                    flexDirection: 'column',
                    margin: '4px',
                    // flex: 1
                  }}
                >
                  <label className={classes.label}>Upload CSV File</label>
                  <label className={classes.inputUpload}>
                    <p>{uploadFile ? uploadFile?.name : 'Choose File'}</p>
                    <input
                      hidden
                      type='file'
                      accept='.csv'
                      onChange={FileUploadFunc}

                      // style={{ display: "none" }}
                    />
                    {/* Choose File */}
                  </label>
                </Grid>
                <div className={classes.btnDiv}>
                  <CustomButton
                    btnStyle={classes.button}
                    clickHandle={createEmailList}
                    btnText={'Upload'}
                  />
                </div>
              </form>
            </Box>
          </Paper>

          <Paper elevation={0} className={classes.root2}>
            <Box
              display='flex'
              flexDirection='column'
              justifyContent='center'
              alignItems='center'
            >
              <div className={classes.mailList}>
                {/* <p className={classes.mailListEmail}>yashwanth@gmail.com</p>
                <p className={classes.mailListEmail}>yashwanth@gmail.com</p>
                <p className={classes.mailListEmail}>yashwanth@gmail.com</p>
                <p className={classes.mailListEmail}>yashwanth@gmail.com</p>
                <p className={classes.mailListEmail}>yashwanth@gmail.com</p>
                <p className={classes.mailListEmail}>yashwanth@gmail.com</p>
                <p className={classes.mailListEmail}>yashwanth@gmail.com</p>
                <p className={classes.mailListEmail}>yashwanth@gmail.com</p>
                <p className={classes.mailListEmail}>yashwanth@gmail.com</p>
                <p className={classes.mailListEmail}>yashwanth@gmail.com</p>
                <p className={classes.mailListEmail}>yashwanth@gmail.com</p>
                <p className={classes.mailListEmail}>yashwanth@gmail.com</p>
                <p className={classes.mailListEmail}>yashwanth@gmail.com</p>
                <p className={classes.mailListEmail}>yashwanth@gmail.com</p>
                <p className={classes.mailListEmail}>yashwanth@gmail.com</p> */}
                <h2>Invalid Mails</h2>
                {response.map((list, index) => {
                  if (list.eformat === 'N') {
                    return <p key={index}> {list.email} </p>;
                  } else {
                    return null;
                  }
                })}
              </div>
            </Box>
          </Paper>
        </div>
      </Grid>

      <Toaster position='top-center'></Toaster>
      <Loader open={loader} />
    </BodyContainer>
  );
};

export default EmailList;
